module.exports = __webpack_public_path__ + "img/1533560037.5c7326dc.jpg";